'use strict';

angular.module('itPurchasingRoutes', ['itPurchasingControllers',
                                      'services.ITPurchasing'])

.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
    $stateProvider

        .state('ITPurchasingRequestCost', {
            url: '/ITPurchasing/UserRequest/WithSignificantCost?searchTerm',
            templateUrl: require('./ItPurchasing.tpl.html'),
            controller: 'ItPurchasingController'
        });
}]);
